"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newAttributeColumnLocator = exports.newWidthForSelectedColumns = exports.newWidthForAllColumnsForMeasure = exports.newWidthForAllMeasureColumns = exports.newWidthForAttributeColumn = exports.newMeasureColumnLocator = exports.isWeakMeasureColumnWidthItem = exports.isAllMeasureColumnWidthItem = exports.isMeasureColumnWidthItem = exports.isAttributeColumnWidthItem = exports.isAbsoluteColumnWidth = exports.isAttributeColumnLocator = exports.isMeasureColumnLocator = exports.UIClick = exports.ColumnEventSourceType = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var sdk_model_1 = require("@gooddata/sdk-model");
//
// types used in implementation internals
//
/**
 * @internal
 */
var ColumnEventSourceType;
(function (ColumnEventSourceType) {
    ColumnEventSourceType["AUTOSIZE_COLUMNS"] = "autosizeColumns";
    ColumnEventSourceType["UI_DRAGGED"] = "uiColumnDragged";
    ColumnEventSourceType["FIT_GROW"] = "growToFit";
})(ColumnEventSourceType = exports.ColumnEventSourceType || (exports.ColumnEventSourceType = {}));
/**
 * @internal
 */
var UIClick;
(function (UIClick) {
    UIClick[UIClick["CLICK"] = 1] = "CLICK";
    UIClick[UIClick["DOUBLE_CLICK"] = 2] = "DOUBLE_CLICK";
})(UIClick = exports.UIClick || (exports.UIClick = {}));
/**
 * Tests whether object is an instance of {@link IMeasureColumnLocator}
 *
 * @public
 */
function isMeasureColumnLocator(obj) {
    return !isEmpty_1.default(obj) && obj.measureLocatorItem !== undefined;
}
exports.isMeasureColumnLocator = isMeasureColumnLocator;
/**
 * Tests whether object is an instance of {@link IAttributeColumnLocator}
 *
 * @public
 */
function isAttributeColumnLocator(obj) {
    return !isEmpty_1.default(obj) && obj.attributeLocatorItem !== undefined;
}
exports.isAttributeColumnLocator = isAttributeColumnLocator;
/**
 * Tests whether object is an instance of {@link IAbsoluteColumnWidth}
 *
 * @public
 */
function isAbsoluteColumnWidth(columnWidth) {
    return Number(columnWidth.value) === columnWidth.value;
}
exports.isAbsoluteColumnWidth = isAbsoluteColumnWidth;
/**
 * Tests whether object is an instance of {@link IAttributeColumnWidthItem}
 *
 * @public
 */
function isAttributeColumnWidthItem(obj) {
    return !isEmpty_1.default(obj) && obj.attributeColumnWidthItem !== undefined;
}
exports.isAttributeColumnWidthItem = isAttributeColumnWidthItem;
/**
 * Tests whether object is an instance of {@link IMeasureColumnWidthItem}
 *
 * @public
 */
function isMeasureColumnWidthItem(obj) {
    return (!isEmpty_1.default(obj) &&
        obj.measureColumnWidthItem !== undefined &&
        obj.measureColumnWidthItem.locators !== undefined);
}
exports.isMeasureColumnWidthItem = isMeasureColumnWidthItem;
/**
 * Tests whether object is an instance of {@link IAllMeasureColumnWidthItem}
 *
 * @public
 */
function isAllMeasureColumnWidthItem(obj) {
    return (!isEmpty_1.default(obj) &&
        obj.measureColumnWidthItem !== undefined &&
        obj.measureColumnWidthItem.locators === undefined &&
        obj.measureColumnWidthItem.locator === undefined);
}
exports.isAllMeasureColumnWidthItem = isAllMeasureColumnWidthItem;
/**
 * Tests whether object is an instance of {@link IWeakMeasureColumnWidthItem}
 *
 * @public
 */
function isWeakMeasureColumnWidthItem(obj) {
    return (!isEmpty_1.default(obj) &&
        obj.measureColumnWidthItem !== undefined &&
        obj.measureColumnWidthItem.locator !== undefined);
}
exports.isWeakMeasureColumnWidthItem = isWeakMeasureColumnWidthItem;
/**
 * @internal
 */
function newMeasureColumnLocator(measureOrId) {
    var measureIdentifier = sdk_model_1.measureLocalId(measureOrId);
    return {
        measureLocatorItem: {
            measureIdentifier: measureIdentifier,
        },
    };
}
exports.newMeasureColumnLocator = newMeasureColumnLocator;
/**
 * Creates width item that will set width of a column which contains values of a row attribute.
 *
 * @param attributeOrId - attribute specified by value or by localId reference
 * @param width - width in pixels
 * @param allowGrowToFit - indicates whether the column is allowed to grow if the table's growToFit is enabled
 * @public
 */
function newWidthForAttributeColumn(attributeOrId, width, allowGrowToFit) {
    var growToFitProp = allowGrowToFit !== undefined ? { allowGrowToFit: allowGrowToFit } : {};
    return {
        attributeColumnWidthItem: {
            attributeIdentifier: sdk_model_1.attributeLocalId(attributeOrId),
            width: tslib_1.__assign({ value: width }, growToFitProp),
        },
    };
}
exports.newWidthForAttributeColumn = newWidthForAttributeColumn;
/**
 * Creates width item that will set width for all measure columns in the table.
 *
 * @param width - width in pixels
 * @param allowGrowToFit - indicates whether the column is allowed to grow if the table's growToFit is enabled
 * @public
 */
function newWidthForAllMeasureColumns(width, allowGrowToFit) {
    var growToFitProp = allowGrowToFit !== undefined ? { allowGrowToFit: allowGrowToFit } : {};
    return {
        measureColumnWidthItem: {
            width: tslib_1.__assign({ value: width }, growToFitProp),
        },
    };
}
exports.newWidthForAllMeasureColumns = newWidthForAllMeasureColumns;
/**
 * Creates width item that will set width for all columns containing values of the provided measure.
 *
 * @param measureOrId - measure specified either by value or by localId reference
 * @param width - width in pixels
 * @param allowGrowToFit - indicates whether the column is allowed to grow if the table's growToFit is enabled
 * @public
 */
function newWidthForAllColumnsForMeasure(measureOrId, width, allowGrowToFit) {
    var locator = newMeasureColumnLocator(measureOrId);
    var growToFitProp = allowGrowToFit !== undefined ? { allowGrowToFit: allowGrowToFit } : {};
    return {
        measureColumnWidthItem: {
            width: tslib_1.__assign({ value: width }, growToFitProp),
            locator: locator,
        },
    };
}
exports.newWidthForAllColumnsForMeasure = newWidthForAllColumnsForMeasure;
/**
 * Creates width item that will set width for all columns containing values of the provided measure.
 *
 * See also {@link newAttributeColumnLocator} to learn more about the attribute column locators.
 *
 * @param measureOrId - measure specified either by value or by localId reference
 * @param locators - attribute locators to narrow down selection
 * @param width - width in pixels
 * @param allowGrowToFit - indicates whether the column is allowed to grow if the table's growToFit is enabled
 * @public
 */
function newWidthForSelectedColumns(measureOrId, locators, width, allowGrowToFit) {
    var measureLocator = newMeasureColumnLocator(measureOrId);
    var growToFitProp = allowGrowToFit !== undefined && width !== "auto" ? { allowGrowToFit: allowGrowToFit } : {};
    // Note: beware here. The attribute locators _must_ come first for some obscure, impl dependent reason
    return {
        measureColumnWidthItem: {
            width: tslib_1.__assign({ value: width }, growToFitProp),
            locators: tslib_1.__spreadArrays(locators, [measureLocator]),
        },
    };
}
exports.newWidthForSelectedColumns = newWidthForSelectedColumns;
/**
 * Creates a new attribute column locator - this is used to narrow down location of measure columns in pivot table, where
 * measures are further scoped by different attribute elements - imagine pivot table with defined for measure 'Amount' and column
 * attribute 'Product'. The table will have multiple columns for the 'Amount' measure - each for different element of the
 * 'Product' attribute. In this context, identifying particular measure columns needs to be more specific.
 *
 * The attribute column locator can match either single element of particular attribute, or all elements of particular
 * attribute.
 *
 * @param attributeOrId - column attribute specified by either value or by localId reference
 * @param element - optionally specify attribute element URI or primary key; if not specified, the locator will match
 *  all elements of the attribute
 * @public
 */
function newAttributeColumnLocator(attributeOrId, element) {
    return {
        attributeLocatorItem: {
            attributeIdentifier: sdk_model_1.attributeLocalId(attributeOrId),
            element: element,
        },
    };
}
exports.newAttributeColumnLocator = newAttributeColumnLocator;
//# sourceMappingURL=columnWidths.js.map